/**
 * Super Admin checklist — verify each item before approving Stripe Connect access.
 * @see docs/STRIPE_CONNECT_ADMIN_CHECKLIST.md
 */

export interface StripeConnectApprovalChecklistItem {
  id: string;
  title: string;
  description: string;
}

export const STRIPE_CONNECT_APPROVAL_CHECKLIST: StripeConnectApprovalChecklistItem[] = [
  {
    id: 'legitimate_business',
    title: 'Legitimate business identity',
    description:
      'Business name, email, and phone look real and match the services offered (not generic, disposable, or misleading).',
  },
  {
    id: 'owner_matches_business',
    title: 'Owner matches the business',
    description:
      'The Firebase account / profile appears to be the actual operator of this business (not a duplicate or impersonation).',
  },
  {
    id: 'services_appropriate',
    title: 'Services are appropriate for BookAPT',
    description:
      'Industry and services are allowed on the platform (no prohibited categories: illegal goods, adult, gambling, etc.).',
  },
  {
    id: 'contact_verifiable',
    title: 'Contact information is verifiable',
    description:
      'Email domain, website, or phone can be reasonably verified (business site, Google listing, or prior BookAPT activity).',
  },
  {
    id: 'subscription_or_intent',
    title: 'Good-faith platform use',
    description:
      'Business has completed setup (profile, services/products) or has an active subscription / clear intent to operate legitimately.',
  },
  {
    id: 'no_fraud_signals',
    title: 'No obvious fraud or abuse signals',
    description:
      'No red flags: many accounts from same pattern, chargeback history, spam signups, or mismatched location/industry.',
  },
  {
    id: 'merchant_terms_current',
    title: 'Merchant payment terms accepted (current version)',
    description:
      'Seller accepted the current merchant payment terms version shown on the request (all required checkboxes).',
  },
  {
    id: 'refund_policy_clear',
    title: 'Refund / cancellation responsibility understood',
    description:
      'Seller understands they handle refunds, disputes, and chargebacks on their connected payment account.',
  },
];

export const STRIPE_CONNECT_CHECKLIST_IDS: string[] =
  STRIPE_CONNECT_APPROVAL_CHECKLIST.map((c) => c.id);
